module.exports = __webpack_public_path__ + "static/img/qh1-6.33b5dad.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/qh1-6.png
// module id = 709
// module chunks = 0